import { fromJS } from 'immutable';
import { isString } from '../../../../../form/formUtilities';

export const marigramSearchModel = fromJS({
  name: 'marigramSearchForm',
  initialValues: {
    id: '',
    minId: '',
    maxId: '',
    minYear: '',
    maxYear: '',
    minMonth: '',
    maxMonth: '',
    minDay: '',
    maxDay: '',
    regionCode: '',
    country: '',
    location: '',
    state: '',
    tsunamiEventId: '',
    assocData: '',
    minLatitude: '',
    maxLatitude: '',
    minLongitude: '',
    maxLongitude: '',

    radios: {
      locStart: '',
      locMatch: '',
      locInclude: '',
      locNot: '',
      locationSearchType: 'locInclude',
      loc: '',
    },
  },
});

export const toSearchParameters = (model) => {
  const search = model.toJS();
  const {
    radios: {
      locationSearchType,
      loc,
    },
  } = search;

  if (locationSearchType) {
    search[locationSearchType] = loc;
  }

  delete search.radios;

  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
